/**
 * FILE-OVERVIEW:
 * - 役割: MUI Switch の共通スタイルラッパー。
 * - 主な連携: FilterSidebar.js, MemoFilterSidebar.js
 * - 本番運用上の注意: テーマ依存の色変更は他画面の視認性に影響する。
 */

import { styled, Switch } from '@mui/material';
import type { SwitchProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomSwitchBase = (props: SwitchProps) => {
  const theme = useTheme();
  // MUI の Switch は theme を props として受け取らない（型にも無い）が、
  // 既存実装がそのまま渡しているため挙動を変えずに型だけ通している。
  // 渡す必要があるかは別途整理する
  const legacyThemeProp = { theme } as unknown as Partial<SwitchProps>;
  return <Switch {...props} {...legacyThemeProp} />;
};

const CustomSwitch = styled(CustomSwitchBase)(({ theme }) => ({
  width: 50,
  height: 28,
  padding: 5,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(4px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(20px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.switch?.on || '#1976d2',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#fff',
    width: 24,
    height: 24,
    boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 14 / 2,
    backgroundColor: theme.palette.switch?.off || '#bdbdbd',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default CustomSwitch;